export default "__VITE_ASSET__CfIXLfcQ__"